import { FluxStandardAction } from "__utils/type";
import * as Actions from "../../constants/actions";


export const fetchGetProfileView = (ucc:string): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_PROFILE_VIEW,
        payload: {
            ucc: ucc
        }        
    }
};
export const fetchGetProfileViewSuccess = (data: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_PROFILE_VIEW_SUCCESS,
        payload: {
            data: data
        }
        
    }
};
export const fetchGetProfileViewError = (error:any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_PROFILE_VIEW_FAILURE,
        payload: {
            data: error
        }
        
    }
};
export const updateProfileViewError = (error:any): FluxStandardAction => {
    return {
        type: Actions.UPDATE_PROFILE_VIEW_ERROR,
        payload: {
            data: error
        }
        
    }
};

// export const setProfileViewObject = (profileView: any): FluxStandardAction => {
//     return {
//         type: Actions.SET_PROFILE_VIEW_OBJECT,
//         payload: profileView
//     }
// };
